<template>

  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb">
        <li class="breadcrumb-item" @click="$router.push('/accountancy')">Contabilidad</li>
        <li class="breadcrumb-item active" aria-current="page">Reporte por TRX con factor</li>
      </ol>
    </nav>
    <div class="container-fluid">
      <div class="row justify-content-md-center" style="margin-top:20px;">
        <div class="col-md-12">
          <md-card>
            <md-card-content>
              <div class="row justify-content-md-center">
                <div class="col-md-3">
                  <md-datepicker v-model="from" md-immediately :md-disabled-dates="disabledDates2">
                    <label>De:</label>
                  </md-datepicker>
                </div>
                <div class="col-md-3">
                  <md-datepicker v-model="to" md-immediately :md-disabled-dates="disabledDates">
                    <label>A:</label>
                  </md-datepicker>
                </div>
                <div class="col-md-2">
                  <md-field>
                    <label>TRX(s)</label>
                    <md-select v-model="selected_transactions" multiple>
                      <md-option v-for="(transaction, idx) in transactions" :value="transaction.trx_type" :key="idx">
                        {{ transaction.trx_type }}
                      </md-option>
                    </md-select>
                  </md-field>
                </div>
                <div class="col-md-2">
                  <md-field>
                    <label>Factor</label>
                    <md-input v-model="factor" type="number" min="0" step="0.01"></md-input>
                  </md-field>
                </div>
                <div class="col-md-1">
                  <md-button class="md-raised md-primary" v-on:click="getReport()">Buscar</md-button>
                </div>
                <div class="col-md-1">
                  <md-button class="md-raised md-primary" style="background-color: green" v-on:click="exportarCSV()">
                    <md-icon>save</md-icon>
                    CSV
                  </md-button>
                </div>
              </div>
            </md-card-content>
          </md-card>
        </div>
      </div>

      <div class="row justify-content-md-center" style="margin-top:20px;">
        <div class="col-md-12">
          <md-card>
            <md-card-content>
              <md-table>
                <md-table-row>
                  <md-table-head style="text-align: center">No. consecutivo</md-table-head>
                  <md-table-head style="text-align: center">Fecha (por día)</md-table-head>
                  <md-table-head style="text-align: center">Monto del día</md-table-head>
                  <md-table-head style="text-align: center">Monto del día x factor</md-table-head>
                </md-table-row>
                <md-table-row v-for="(renglon, index) in data" :key="index">
                  <md-table-cell style="text-align: center">{{ formatPrice(index + 1) }}</md-table-cell>

                  <md-table-cell style="text-align: center;">
                    {{ renglon.fecha }}
                  </md-table-cell>

                  <md-table-cell style="text-align: center">
                    ${{ formatPrice(renglon.monto, 2) }}
                  </md-table-cell>

                  <md-table-cell style="text-align: center">
                    ${{ formatPrice(renglon.monto * factor, 2) }}
                  </md-table-cell>
                </md-table-row>
              </md-table>
            </md-card-content>
          </md-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script lang="js">

import {Currency} from "@/models/Security/Currency";

export default {
  name: 'src-views-admin-accounting-trx-con-factor',
  props: [],
  mounted() {
    this.from = this.getFrom();
    this.to = this.getTo();
    axios.get('/api/accounting/transactions').then(response => {
      this.transactions = response.data.data;
    });
  },
  data() {
    return {
      data: [],
      today: new Date(),
      from: null,
      to2: null,
      to: null,
      factor: 0.05,
      transactions: [],
      selected_transactions: ['I111', 'I112', 'C111'],
      disabledDates: date => {
        return date >= this.today ||
          (date.getFullYear() === this.today.getFullYear() &&
            date.getMonth() === this.today.getMonth() &&
            date.getDate() === this.today.getDate());
      },
      disabledDates2: date => {
        return date > new Date(this.to2) || date >= this.today ||
          (date.getFullYear() === this.today.getFullYear() &&
            date.getMonth() === this.today.getMonth() &&
            date.getDate() === this.today.getDate());
      }
    }
  },
  watch: {
    to: function () {
      if (this.from > this.to) this.from = this.to;
      this.to2 = new Date(this.to);
      this.to2.setDate(this.to2.getDate() + 1);
    }
  },
  methods: {
    getFrom() {
      var date = new Date();
      date.setDate(date.getDate());
      date.setMonth(date.getMonth() - 1);
      if (date.getMonth() < 10 && date.getDate() < 10) return date.getFullYear() + '-0' + (date.getMonth() + 1) + '-0' + date.getDate();
      if (date.getMonth() < 10) return date.getFullYear() + '-0' + (date.getMonth() + 1) + '-' + date.getDate();
      if (date.getDate() < 10) return date.getFullYear() + '-' + (date.getMonth() + 1) + '-0' + date.getDate();
      return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate();
    },
    getTo() {
      var date = new Date();
      date.setDate(date.getDate() - 1);
      if (date.getMonth() < 9 && date.getDate() < 10) return date.getFullYear() + '-0' + (date.getMonth() + 1) + '-0' + date.getDate();
      if (date.getMonth() < 9) return date.getFullYear() + '-0' + (date.getMonth() + 1) + '-' + date.getDate();
      if (date.getDate() < 10) return date.getFullYear() + '-' + (date.getMonth() + 1) + '-0' + date.getDate();
      return date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    },
    getReport() {
      this.data = [];
      Vue.toasted.show('Cargando...', {position: 'bottom-center', closeOnSwipe: false});
      axios.post('/api/accounting/report/bytrxwithfactor', {
        from: this.from,
        to: this.to,
        trx: this.selected_transactions
      }).then(response => {
        Vue.toasted.clear();
        Vue.toasted.show('¡¡ Reporte cargado correctamente !!', {
          position: 'bottom-center',
          type: 'success',
          closeOnSwipe: false,
          duration: 10000
        });
        this.data = response.data.transactions;
      }).catch(error => {
        Vue.toasted.clear();
        Vue.toasted.show('Ha ocurrido un error', {
          position: 'bottom-center',
          type: 'error',
          closeOnSwipe: true,
          duration: 10000
        });
      });
    },
    formatPrice(value, decimales = 0) {
      let val = (value / 1).toFixed(decimales).replace(',', '.')
      return Currency.format(parseFloat(val))
    },
    exportarCSV() {
      var csv = [];
      var rows = document.querySelectorAll("table tr");

      llenar:
        for (var i = 0; i < rows.length; i++) {
          var row = [], cols = rows[i].querySelectorAll("td, th");

          for (var j = 0; j < cols.length; j++)
            if (cols[j].innerText == 'Params') {
              break llenar;
            } else {
              row.push(cols[j].innerText.replace(new RegExp(',', 'g'), ''));
            }

          csv.push(row.join(","));
        }

      // Download CSV
      var csvFile;
      var downloadLink;

      // CSV FILE
      csvFile = new Blob([csv.join("\n")], {type: "text/csv;charset=utf-8"});

      // Download link
      downloadLink = document.createElement("a");

      // File name
      downloadLink.download = 'ReportePorTrxConFactor.csv';

      // We have to create a link to the file
      downloadLink.href = window.URL.createObjectURL(csvFile);

      // Make sure that the link is not displayed
      downloadLink.style.display = "none";

      // Add the link to your DOM
      document.body.appendChild(downloadLink);

      // Lanzamos
      downloadLink.click();
    },
  },
  computed: {}
}


</script>

<style scoped lang="scss">
.src-views-admin-accounting-trx-con-factor {

}
</style>
